import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import ItemListContext from './ItemListContext';

var ItemListItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ItemListItem, _Component);

  function ItemListItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "node", null);

    _defineProperty(_assertThisInitialized(_this), "highlighted", false);

    _defineProperty(_assertThisInitialized(_this), "highlight", function () {
      if (!_this.props.disabled) {
        _this.itemList.setHighlightedIndex(_this.props.index, {
          maybeScrollIntoView: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "select", function () {
      if (!_this.props.disabled) {
        _this.itemList.selectItem(_this.props.index);
      }
    });

    return _this;
  }

  var _proto = ItemListItem.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setNode();
    this.unsubscribeItem = this.itemList.subscribeItem(this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(lastProps) {
    if (lastProps.index !== this.props.index) {
      // sort items array since index has changed and is now misplaced
      this.itemList.items.sort(function (a, b) {
        return a.props.index - b.props.index;
      });
      this.setNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeItem();
  };

  _proto.setNode = function setNode() {
    this.node = document.getElementById(this.itemList.getItemId(this.props.index));
  };

  _proto.getNode = function getNode() {
    return this.node;
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ItemListContext.Consumer, null, function (itemList) {
      if (!_this2.itemList) {
        _this2.itemList = itemList;
      }

      return _this2.props.children({
        id: itemList.getItemId(_this2.props.index),
        clearHighlight: itemList.clearHighlightedIndex,
        highlight: _this2.highlight,
        highlighted: _this2.highlighted,
        select: _this2.select,
        selected: itemList.isItemSelected(_this2.props.data)
      });
    });
  };

  return ItemListItem;
}(Component);

export default ItemListItem;